module.exports = __webpack_public_path__ + "static/media/logo-report-footer.5a6a8c27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/branding/complex-solutions/logo-report-footer.svg
// module id = 511
// module chunks = 0